<template>
  <div>
    <div v-if="!isReadOnly" class="mb-3" :class="addVariant">
      <div class="mb-3">
        <em v-if="icon" class="fas  text-green mr-1" :class="icon" />
        <span class="data-name">{{ label }}</span>
      </div>
      <div class="d-flex align-items-center">
        <div
          :class="{
            'w-90': !isAutoSelect,
            'w-100': isAutoSelect,
          }"
        >
          <div class="row">
            <div :class="[isOtherSelected ? 'col-6' : 'col-12']">
              <custom-drop-down
                v-if="isDropDown"
                id="options"
                v-model="innerModel"
                :clearable="true"
                fieldkey="id"
                fieldname="name"
                :options="options"
                placeholder="Seleccione"
                @input="onSelect"
              />
              <custom-input
                v-else
                v-model="innerModel"
                :label="label"
                :placeholder="placeholder"
                @keypress.enter.prevent="save"
              />
            </div>
            <div v-if="isOtherSelected" class="col-6">
              <custom-auto-complete
                v-model="searchSettings.term"
                class="search-autocomplete"
                :debounce-time="searchSettings?.debounceTime || 2000"
                :display-text-name="searchSettings?.displayProp || 'name'"
                :get-result-value="searchSettings.resultMap"
                :placeholder="searchSettings?.placeholder || 'Buscar'"
                :search="search"
                @submit="searchSubmit"
              />
            </div>
          </div>
        </div>
        <div
          v-if="!isAutoSelect"
          class="w-10 d-flex justify-content-end"
          :class="{ '': !icon }"
        >
          <action-button
            :disabled="!innerModel"
            i="fas fa-save"
            text="Añadir"
            variant="success w-100 ml-2"
            @click="save"
          />
        </div>
      </div>
    </div>
    <custom-separator v-if="separator" :text="separator" />

    <custom-result-not-found
      v-if="!model.length"
      class="my-3"
      text="No hay información disponible."
    />

    <draggable
      :disabled="isReadOnly || !draggable"
      handle=".drag-handle"
      :list="model"
      @end="onDragEnd"
    >
      <div
        v-for="(item, index) in list"
        :key="item.id || index"
        class="rounded p-3 bg-gray my-3 "
        :class="{ 'drag-handle': draggable }"
      >
        <div class="d-flex align-items-center justify-content-between">
          <div class="d-flex align-items-center">
            <div>
              <div
                class="d-inline rounded"
                :class="draggable ? 'indicator-alt' : 'indicator bg-success'"
              >
                {{ index + 1 }}
              </div>
              <i
                v-if="!isReadOnly && draggable"
                class="fas fa-grip-vertical m-2 cursor-move drag-handle-icon"
                title="Arrastrar"
              />
              <div class="d-inline ml-2">{{ item?.name ?? item | empty }}</div>
            </div>
          </div>
          <div v-if="!isReadOnly">
            <div class="d-flex align-items-center justify-content-between">
              <Chip
                v-if="hasChip"
                class="mr-2"
                :color="index === 0 ? '#D2F7ED' : '#FFEBEB'"
                :text-color="index === 0 ? '#2DB782' : '#FF5B5C'"
              >
                <span v-text="index === 0 ? 'Primario' : 'Secundario'" />
              </Chip>
              <i
                class="far fa-times-circle text-danger pointer"
                @click="remove(index)"
              />
            </div>
          </div>
        </div>
      </div>
    </draggable>

    <div v-if="showMore" class="row mx-1">
      <div class="col text-center">
        <action-button
          i="far fa-chevron-circle-down"
          variant="outline-success custom-view-more actionButton rounded-pill"
          @click="handlerMore"
        >
          Ver más
        </action-button>
      </div>
    </div>
  </div>
</template>

<script>
import alertMixin from '@quisit/mipe-utils/mixins/alert.mixin.js';

import CustomInput from 'CustomInput';
import ActionButton from 'ActionButton';
import CustomSeparator from 'custom-separator';
import CustomResultNotFound from 'custom-result-not-found';
import CustomDropDown from 'custom-drop-down';
import Draggable from 'vuedraggable';
import Chip from './Chip.vue';
import CustomAutoComplete from '@/components/common/CustomAutoComplete.vue';

export default {
  name: 'CustomTodo',
  components: {
    CustomInput,
    ActionButton,
    CustomSeparator,
    CustomResultNotFound,
    CustomDropDown,
    Draggable,
    Chip,
    CustomAutoComplete,
  },
  mixins: [alertMixin],
  props: {
    value: {
      type: Array,
      required: true,
      default: () => [],
    },
    options: {
      type: Array,
      required: false,
      default: () => [],
    },
    label: {
      type: String,
      default: () => 'Valor:',
    },
    icon: {
      type: String,
      default: () => null,
    },
    placeholder: {
      type: String,
      default: () => null,
    },
    separator: {
      type: String,
      default: () => null,
    },
    gender: {
      type: String,
      default: () => 'male',
    },
    isReadOnly: {
      type: Boolean,
      default: () => false,
    },
    isDropDown: {
      type: Boolean,
      default: () => false,
    },
    isAutoSelect: {
      type: Boolean,
      default: () => false,
    },
    hasChip: {
      type: Boolean,
      default: () => false,
    },
    draggable: {
      type: Boolean,
      default: () => false,
    },
    addVariant: {
      type: String,
      default: () => '',
    },
    hasPagination: {
      type: Boolean,
      default: () => false,
    },
    paginationCount: {
      type: Number,
      default: () => 5,
    },
    hasOther: {
      type: Boolean,
      default: () => false,
    },
    searchSettings: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      innerModel: null,
      localSelected: [],
      currentCount: this.paginationCount,
    };
  },
  computed: {
    model: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('input', value);
      },
    },
    showMore() {
      return (
        this.hasPagination &&
        this.model.length > this.currentCount &&
        this.model.length > this.paginationCount
      );
    },
    list() {
      return this.hasPagination
        ? this.model.slice(0, this.currentCount)
        : this.model;
    },
    isOtherSelected() {
      return (
        this.hasOther && this.searchSettings?.option?.id === this.innerModel?.id
      );
    },
  },
  methods: {
    isDuplicate() {
      const item = this.isOtherSelected
        ? this.searchSettings.selected
        : this.innerModel;
      const value = this.isDropDown
        ? item?.name?.toLowerCase()
        : this.innerModel.trim().toLowerCase();
      if (!value) return false;
      return this.model
        .filter((x) => x)
        .map((x) =>
          this.isDropDown ? x.name?.toLowerCase() : x.trim().toLowerCase()
        )
        .includes(value);
    },
    clear() {
      if (this.isOtherSelected) {
        this.searchSettings.selected = null;
        this.searchSettings.term = '';
      } else this.innerModel = null;
    },
    save() {
      const item = this.isOtherSelected
        ? this.searchSettings.selected
        : this.innerModel;
      const isValid = !!item;
      if (!isValid) return;

      if (this.isDuplicate()) {
        this.ShowToast('', `Ya existe este valor en la lista.`, 'error');
        return;
      }

      const result = [...this.model, item];
      this.$emit('input', result);
      this.clear();
      if (this.hasPagination && this.currentCount < this.paginationCount) {
        this.currentCount++;
      }
    },
    onSelect() {
      if (this.isAutoSelect && !this.isOtherSelected) {
        this.save();
      }
    },
    async remove(index) {
      const confirmed = await this.ShowCancelModal(
        'Confirmación',
        `¿Está seguro que desea eliminar este valor de la lista?`,
        'Si',
        'No'
      );

      if (!confirmed) return;
      const result = [...this.model];
      result.splice(index, 1);
      this.$emit('input', result);
      this.currentCount--;
    },
    onDragEnd() {
      this.$emit('input', [...this.model]);
    },
    handlerMore() {
      this.currentCount++;
    },
    search(term) {
      if (!term?.trim()) return [];
      if (term.length < this.searchSettings?.termLength ?? 3) return [];
      return this.searchSettings.handler(term);
    },
    searchSubmit(item) {
      if (!item) return;
      this.searchSettings.selected = item;
      this.save();
    },
  },
};
</script>
<style scoped>
div.was-Invalidated-select ::v-deep .v-select > div {
  background-color: #f7d7da;
  border: 1px solid #ff0018 !important;
}
::v-deep div.was-Invalidated {
  border: none !important;
}
.pointer {
  cursor: pointer;
}
.drag-handle {
  cursor: grab;
}

.drag-handle-icon {
  color: #e2e2e2;
}

.drag-handle:active {
  cursor: grabbing;
  background-color: #3f5b60 !important;
  color: white !important;
}
.indicator {
  font-size: 18px;
  padding: 6px 10px;
  font-weight: bold;
  text-align: center;
  color: white;
}

.indicator-alt {
  font-size: 16px;
  padding: 6px 10px;
  font-weight: bold;
  text-align: center;
  color: #aab7b1;
}
.search-autocomplete ::v-deep .custom-autocomplete > label {
  display: none;
}
</style>
